import { useEffect, useRef } from "react";
import { apiFetch } from "@/lib/api";

export const engagementApi = {
  radar: () => apiFetch(`/engagement/radar`, { auth: false }),
  radarTopic: (slug) => apiFetch(`/engagement/radar/${encodeURIComponent(slug)}`, { auth: false }),
  brief: () => apiFetch(`/engagement/brief`, { auth: false }),
  onThisDay: () => apiFetch(`/engagement/on-this-day`, { auth: false }),
  poll: () => apiFetch(`/engagement/poll?anon_id=${anonId()}`, { auth: true }),
  vote: (choice) => apiFetch(`/engagement/poll/vote`, { method: "POST", auth: true, body: { choice, anon_id: anonId() } }),
};

export function anonId() {
  let id = localStorage.getItem("readoo_anon_id");
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`).replace(/[^a-z0-9-]/gi, "").slice(0, 40);
    localStorage.setItem("readoo_anon_id", id);
  }
  return id;
}

// Contatori interni dei moduli (base per i futuri Readoo Punti): non bloccano mai l'interfaccia.
export function track(name, meta = {}) {
  apiFetch(`/engagement/event`, { method: "POST", auth: true, body: { name, meta } }).catch(() => {});
}

// Registra "<modulo>_viewed" una volta per sessione, quando il modulo entra davvero nello schermo.
export function useViewed(name, ready = true) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !ready || sessionStorage.getItem(`viewed:${name}`)) return undefined;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { sessionStorage.setItem(`viewed:${name}`, "1"); track(name); io.disconnect(); }
    }, { threshold: 0.5 });
    io.observe(el);
    return () => io.disconnect();
  }, [name, ready]);
  return ref;
}
